import { getAtsKey } from './../../config';
import { ImageShapeType } from '../../interfaces';
import { Environments } from '../../controllers/Environments';
import { ThirdPartyProvider } from './me/providers/types';

export function createThirdPartyDeeplink(provider: ThirdPartyProvider, path: string) {
  const url = new URL(path, provider.params.deeplinkUrlBase);
  const search =
    provider.params.deeplinkQueryParams !== undefined
      ? new URLSearchParams(provider.params.deeplinkQueryParams)
      : undefined;

  if (search) {
    search.forEach((value, key) => url.searchParams.set(key, value));
  }

  return url;
}

const env = Environments();

const fallback = 'https://cdn.services.altibox.net';

export function getAggregatedTitleImage(masterId: string, aspectRatio: ImageShapeType, width: number = 500) {
  if (!masterId || !aspectRatio) {
    return '';
  }

  const cdnUrl = env.getCdnUrl();

  return `${
    cdnUrl ?? fallback
  }/images/titles/${masterId}/${aspectRatio}?api-version=1.0&format=avif&subscription-key=${getAtsKey()}&width=${width}`;
}

export function getAggregatedCollectionImage(collectionSlug: string, aspectRatio: ImageShapeType, width: number = 500) {
  if (!collectionSlug || !aspectRatio) {
    return '';
  }

  const cdnUrl = env.getCdnUrl();

  return `${
    cdnUrl ?? fallback
  }/images/collections/${collectionSlug}/${aspectRatio}?api-version=1.0&format=avif&subscription-key=${getAtsKey()}&width=${width}`;
}

export function getImageByPath(path: string, aspectRatio: ImageShapeType = 'wide', width: number = 500) {
  if (!path) {
    return '';
  }
  const cdnUrl = env.getCdnUrl();
  if (path.includes('https')) {
    return path;
  }
  return `${
    cdnUrl ?? fallback
  }${path}/${aspectRatio}?api-version=1.0&format=avif&subscription-key=${getAtsKey()}&width=${width}`;
}
